/**
 * Shared configuration and types for the layout QR code component.
 */

export interface QRCodeProps {
  /** Encoded QR payload (URL, text, etc.). */
  value?: string;
}

export const DEFAULT_QR_CODE_NODE_SIZE = 100;

export function createInitialQRCodeProps(): QRCodeProps {
  return {
    value: "",
  };
}

/** Square QR size derived from the layout node bounds (min of width and height). */
export function resolveQRCodeRenderSizeFromNode(
  width: unknown,
  height: unknown,
  fallback = DEFAULT_QR_CODE_NODE_SIZE,
): number {
  const w =
    typeof width === "number" && Number.isFinite(width) && width > 0
      ? width
      : fallback;
  const h =
    typeof height === "number" && Number.isFinite(height) && height > 0
      ? height
      : fallback;
  return Math.max(1, Math.round(Math.min(w, h)));
}

export function resolveQRCodeValue(value: unknown): string {
  if (value == null) return "";
  return String(value);
}
